import { CarouselItem } from '@gohighlevel/ghl-ui'
import { Languages } from '@gohighlevel/ghl-ui/dist/types/components/code-editor/types'
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  AGENCY: 'agency',
  ACCOUNT: 'account',
}

export const discussionRoutes = ['channel-overview', 'home']

export const ALLOWED_FILE_TYPES = [
  'image/svg+xml',
  'image/png',
  'image/webp',
  'image/jpg',
  'image/jpeg',
  'image/vnd.microsoft.icon',
]

export const ALLOWED_FILE_TYPES_READABLE = [
  'SVG',
  'PNG',
  'JPG',
  'JPEG',
  'WEBP',
  'ICO',
]

export const COMMUNITIES_RECAPTCHA_SITEKEY =
  '6LfcbMseAAAAAI-EJoB-lUh7_TJaYloLbcbmnhEO'
export const GTagID = 'G-91CZG6XDY5'
export const NO_POST_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/no_posts_icon.svg'
export const GROUP_HOME_ICON =
  'https://staging.cdn.msgsndr.com/assets/communities/community_home.svg'
export const DEFAULT_GROUP_COVER_IMAGE =
  'https://storage.googleapis.com/revex-communities-staging/assets/cover_image-grp.webp'
export const DEFAULT_GROUP_LOGO =
  'https://storage.googleapis.com/revex-communities-staging/assets/CommunitiesDefaultLogo.webp'
export const DEFAULT_COURSE_LOGO =
  'https://storage.googleapis.com/revex-communities-staging/assets/CoursesDefaultLogo.webp'
export const LOGO_PLUS_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/logo-plus.svg'
export const FEATURED_ICON =
  'https://storage.googleapis.com/revex-communities-staging/assets/featured_icon.svg'
export const GIPHY_ATTRIBUTION_ICON_DARK =
  'https://storage.googleapis.com/revex-communities-staging/assets/giphy_attribution_text.png'
export const GIPHY_ATTRIBUTION_ICON_LIGHT =
  'https://storage.googleapis.com/revex-communities-staging/assets/giphy_attribution_text_light.png'
export const SNOW_MAN_LOADER =
  'https://storage.googleapis.com/revex-communities-staging/assets/snow_man_loader_animation.json'
export const UI_PAYMENT_ELEMENT_EVENT = {
  READY: 'ready',
  PROCESSING: 'processing',
  ERROR: 'error',
  SUCCESS: 'success',
  PREPROCESS: 'pre_process',
  CLOSE: 'close',
}
export const CUBE_LOADER = `https://storage.googleapis.com/revex-communities-staging/assets/cube_loader.json`

export const ENVIRONMENT = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  SANDBOX: 'sandbox',
  PRODUCTION: 'production',
}
export const codeOptions = [
  {
    title: 'groupInfo.customCode.customJS',
    tag: 'customJs',
    language: 'javascript' as Languages,
    tabs: false,
  },
  {
    title: 'groupInfo.customCode.customCSS',
    tag: 'customCss',
    language: 'css' as Languages,
    tabs: false,
  },
  {
    title: 'groupInfo.customCode.trackingCode',
    tag: 'trackingcode',
    tabs: true,
  },
]

export enum Platform {
  IOS = 'ios',
  Android = 'android',
}

export const DEFAULT_SAFE_AREA_INSET = 34

export const COMMUNITY_ABOUT_BACKGROUND_IMAGES: CarouselItem[] = [
  {
    key: '1',
    src: 'https://naive-ui.oss-cn-beijing.aliyuncs.com/carousel-img/carousel1.jpeg',
  },
  {
    key: '2',
    src: 'https://naive-ui.oss-cn-beijing.aliyuncs.com/carousel-img/carousel2.jpeg',
  },
  {
    key: '3',
    src: 'https://naive-ui.oss-cn-beijing.aliyuncs.com/carousel-img/carousel3.jpeg',
  },
  {
    key: '4',
    src: 'https://naive-ui.oss-cn-beijing.aliyuncs.com/carousel-img/carousel3.jpeg',
  },
]
